export const AJAX_SPINNER = 'e2e-ajax-spinner';
export const DASHBOARD_FILTER = 'e2e-dashboard-filter';
export const COPY_LINK = 'e2e-copy-link';
export const CHART_CANVAS = 'e2e-chart-canvas';
export const CHART_SINGLE_VALUE = 'e2e-chart-single-value';
export const SHOW_MORE_BUTTON = 'e2e-show-more-button';
export const ADD_NEW_DATASOURCE_BUTTON = 'e2e-add-new-datasource-button';
export const START_NEW_QUERY_BUTTON = 'e2e-start-new-query-button';
export const MAIN_SIDEBAR_ITEM = 'e2e-main-sidebar-item';
export const TABLE_COLUMN_NAME = 'e2e-table-column-name';
export const QUERY_STEP = 'e2e-query-step';
export const FILTER_VALUE_INPUT = 'e2e-filter-value';
export const FILTER_OPERATOR_BUTTON = 'e2e-filter-operator';
export const DISABLE_STEP_BUTTON = 'e2e-disable-step-button';
export const DELETE_STEP_BUTTON = 'e2e-delete-step-button';
export const ADD_DIMENSIONS_BUTTON = 'e2e-add-dimensions-button';
export const SELECT_FORMAT_OPTIONS = 'e2e-select-format-options';
export const ADD_METRICS_BUTTON = 'e2e-add-metrics-button';
export const SHOW_PIE_CHART_BUTTON = 'e2e-show-pie-chart-button';
export const SHOW_BAR_CHART_BUTTON = 'e2e-show-bar-chart-button';
export const SHOW_PIVOT_TABLE_BUTTON = 'e2e-show-pivot-table-button';
export const SHOW_LINE_CHART_BUTTON = 'e2e-show-line-chart-button';
export const SHOW_STACKED_CHART_BUTTON = 'e2e-show-stacked-chart-button';
export const EDIT_QUERY_PRESENTATION_BUTTON =
  'e2e-edit-query-presentation-button';
export const SAVE_QUERY_BUTTON = 'e2e-save-query-button';
export const DASHBOARD_CONTAINER = 'e2e-dashboard-container';
export const SEARCH_QUERIES_INPUT = 'e2e-search-queries-input';
export const WIDGET_NAME_INPUT = 'e2e-widget-name-input';
export const DASHBOARD_FILTER_NAME_INPUT = 'e2e-dashboard-filter-name-input';
export const DASHBOARD_FILTER_TYPE_BUTTON = 'e2e-dashboard-filter-type-button';
export const DASHBOARD_WIDGET_CONFIG_BUTTON =
  'e2e=dashboard-widget-config-button';
export const DASHBOARD_TEXT_FILTER_OPTION_INPUT =
  'e2e-dashboard-text-filter-options-input';
export const SHARE_ACTIVE_BUTTON_PREFIX = 'share-active-button';
export const CACHED_VIEW_LOADING = 'cached-view-loading';
export const CHART_CONFIG_ONBOARDING = 'chart-config-onboarding';
export const COLUMNS_SUBTOTALS_TOGGLE = 'columns-subtotals-toggle';
export const ROWS_SUBTOTALS_TOGGLE = 'rows-subtotals-toggle';
export const NEW_DASHBOARD_NAME_INPUT = 'new-dashboard-name-input';
export const DASHBOARD_ADD_TEXT_BUTTON = 'dashboard-add-text-button';
export const DASHBOARD_ADD_SAVED_QUERY_BUTTON =
  'dashboard-add-saved-query-button';
export const TEXT_WIDGET_ALIGN_CENTER_BUTTON =
  'text-widget-align-center-button';
export const TEXT_WIDGET_DONE_BUTTON = 'text-widget-done-button';
export const DASHBOARD_SAVE_BAR = 'dashboard-save-bar';
export const DATE_TIME_INPUT = 'date-time-input';
export const SEARCH_BAR_CLEAR_BUTTON = 'searchbar-clear-button';

// src/main/resources/templates/public
export const SIGN_UP_FORM = 'e2e-sign-up-form';
export const SIGN_UP_CONFIRMATION = 'e2e-sign-up-confirmation';
export const LOGIN_BUTTON = 'e2e-login-button';

// not only e2e related - probably should be split in future
export const QUERY_NAME_INPUT = 'queryNameTxt';
export const DATASOURCE_NAME_INPUT = 'field-nickname';
export const DATASOURCE_HOST_INPUT = 'field-host';
export const DATASOURCE_USER_INPUT = 'field-user';
export const DATASOURCE_PASSWORD_INPUT = 'field-password';
export const DATASOURCE_DATABASE_INPUT = 'field-database';
// src/main/resources/templates/public
export const SIGN_IN_EMAIL_INPUT = 'sign-in-email';
export const SIGN_IN_PASSWORD_INPUT = 'sign-in-password';
export const SIGN_UP_FIRST_NAME_INPUT = 'sign-up-first-name';
export const SIGN_UP_LAST_NAME_INPUT = 'sign-up-last-name';
export const SIGN_UP_EMAIL_INPUT = 'sign-up-email';
export const SIGN_UP_PASSWORD_INPUT = 'sign-up-password';
export const SIGN_UP_PASSWORD_CONFIRMATION_INPUT = 'sign-up-confirm-password';
export const SIGN_UP_BUTTON = 'sign-up-action';
export const EDITABLE_FIELD_INPUT = 'editable-field-input';
export const CONNECT_DATABASE_CONTINUE_NEXT_STEP =
  'connect-database-continue-next-step';
export const CONNECT_DATABASE_SETUP_TYPE = 'connect-database-setup-type';
export const CONNECT_DATABASE_DATABASE_TYPE = 'connect-database-database-type';
export const CONNECT_DATABASE_HOSTING_PROVIDER_TYPE =
  'connect-database-hosting-provider-type';
